@if (form() && form().parent) {
  <form [formGroup]="$any(form().parent)">
    <div>
      <span class="bold">{{ filterByLabel | translate }}</span>
      <span class="aos-report-groups-filter-criteria__section-description mb-1">
        {{ allConditionsAppliedLabel | translate }}
        <span class="bold">&nbsp;AND&nbsp;</span>
        {{ operatirMeaningLabel | translate }}
      </span>

      @for (filter of filterCriteriaFormArrayControls(); track filter; let index = $index) {
        <article>
          <aos-report-groups-dynamic-filter
            [form]="$safeNavigationMigration($any(form())?.at(index))"
            [items]="initialFilters().items"
            [defaultValue]="initialFilters().selected[0]"
            (remove)="removeFilterAtIndex(index)"
          ></aos-report-groups-dynamic-filter>
        </article>
      }

      <ui-button
        class="aos-report-groups-filter-criteria__add-button"
        [disabled]="isAllFiltersSelected"
        [themeColor]="'primary'"
        (click)="addFilter()"
      >
        <span>+</span>
        <span>{{ addLabel | translate }}</span>
      </ui-button>
    </div>
  </form>
}
